var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2efea;stroke:#bfc0c0;}.cls-1,.cls-2{stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:none;stroke:#08425c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 26.5,
    r: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.5,
    y1: 26.5,
    x2: 46.5,
    y2: 26.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "41.21 21.21 46.5 26.5 41.21 31.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "11.79 21.21 6.5 26.5 11.79 31.79"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.81392ff7f804fe3fcaa225a121caa05f.svg";
export { ForwardRef as ReactComponent };